import { render, staticRenderFns } from "./SecuritySetting.vue?vue&type=template&id=28c3cb1c&scoped=true&"
import script from "./SecuritySetting.vue?vue&type=script&lang=js&"
export * from "./SecuritySetting.vue?vue&type=script&lang=js&"
import style0 from "./SecuritySetting.vue?vue&type=style&index=0&id=28c3cb1c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c3cb1c",
  null
  
)

export default component.exports